module.exports = __webpack_public_path__ + "media/application/images/img/svg/arrow_left-11911410dca2de148f30954eb2fd5eab.svg";